document.addEventListener("DOMContentLoaded", code);

if (window.acf) {
  window.acf.addAction('render_block_preview/type=timeline', code);
}

function code(event) {
  // Query all timeline blocks
  var timelineBlocks = document.getElementsByClassName('timeline'); // Check existence of timeline blocks

  if (timelineBlocks.length) {
    var _loop = function _loop(i) {
      // Query show more button
      var showMore = timelineBlocks[i].querySelector('.show-more');

      if (showMore != null) {
        // On click of show more button
        showMore.addEventListener('click', function (event) {
          //Query all hidden years of given timeline block
          var hiddenYears = timelineBlocks[i].querySelectorAll('.hidden'); // Foreach over each hidden year

          hiddenYears.forEach(function (el) {
            // Remove each hidden class from 'el'
            el.classList.remove('hidden'); // Add !hidden class to show more button

            event.target.classList.add('!hidden');
          });
        });
      }
    };

    // Loop over each timeline block
    for (var i = 0; i < timelineBlocks.length; i++) {
      _loop(i);
    }
  }
}